export enum DefectType {
  Reported = 1,
  Verified = 2,
}

export const defectTypes = new Map<number, string>([
  [DefectType.Reported, 'reported'],
  [DefectType.Verified, 'verified'],
]);
